/**
 * Third step of the validate path: the details held up, here is what the carrier charges for them.
 * The merchant picks a rate and approves, which regenerates the label and closes the flow.
 */
import { observer } from "mobx-react";
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import IconCheck from "../../../../../../../components/icons/icon-check/icon-check";
import Icon from "../../../../../../../components/icons/icon/icon";
import { Button } from "../../../../../../../components/inputs/button/button";
import ListLayout, { LIST_LAYOUT_SPACING_VARIANT } from "../../../../../../../components/layouts/list-layout/list-layout";
import { IResolveLabelErrorScreenProps } from "../../../../stores/rma-action-store/resolve-label-error-action-store";
import ShippingRateDropdown from "../../shared/shipping-rate-dropdown/shipping-rate-dropdown";
import "./select-shipping-rate-screen.scss";

const SelectShippingRateScreen: React.FC<IResolveLabelErrorScreenProps> = observer(({ store }) => {
    const shippingRates = store.validateShippingDetails.shippingRates;

    return (
        <div className="select-shipping-rate-screen">
            <ListLayout>
                <ListLayout spacingVariant={LIST_LAYOUT_SPACING_VARIANT.SMAll}>
                    <div className="select-shipping-rate-screen-validated">
                        <div className="select-shipping-rate-screen-validated-icon">
                            <Icon Component={IconCheck} color="var(--color-neutral-1-white)" />
                        </div>
                        <FontBody1 color={FONT_COLOR.NEUTRAL12} variant={[FONT_VARIANT.BOLD]}>
                            We were able to successfully validate the RMA's shipping details!
                        </FontBody1>
                    </div>

                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>
                        Choose one of the available shipping rates to generate your return label:
                    </FontBody1>
                </ListLayout>

                <ShippingRateDropdown
                    rates={shippingRates.rates}
                    selectedRate={shippingRates.selectedRate}
                    onSelect={shippingRates.setSelectedRate}
                />

                <div className="resolve-label-error-modal-actions">
                    <Button
                        text="Approve RMA"
                        hasLoader
                        isLoading={store.validateShippingDetails.isApproving}
                        disabled={!shippingRates.selectedRate}
                        onClick={() => { void store.approve(); }}
                    />
                </div>
            </ListLayout>
        </div>
    );
});

export default SelectShippingRateScreen;
